import { render, staticRenderFns } from "./InsightsNav.vue?vue&type=template&id=e17abb60&scoped=true"
import script from "./InsightsNav.vue?vue&type=script&lang=js"
export * from "./InsightsNav.vue?vue&type=script&lang=js"
import style0 from "./InsightsNav.vue?vue&type=style&index=0&id=e17abb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17abb60",
  null
  
)

export default component.exports